<!-- -----------------------------------------------------------------------------
<copyright file="edialog.component.html" company="ecoInsight, Inc.">
  Copyright © ecoInsight, Inc. All rights reserved.
</copyright>
------------------------------------------------------------------------------ -->

<section class="edialog {{ id }} default">
  <header>
    <h2>{{ title | translate }}</h2>
    @if (showCloseButton) {
    <a
      tabindex="0"
      role="button"
      class="i-cross-icon"
      (click)="close()"
      data-testid="ed-can-btn"
    ></a>
    }
  </header>
  <div class="content"></div>
</section>
@if (showOverlay) {
<div class="elight-box"></div>
}
